import { MultiSelectChangeEvent } from 'primereact/multiselect';

import { ButtonComponent } from '../../../../components/ButtonComponen';
import { InputComponent } from '../../../../components/InputComponent';
import { CalendarComponent } from '../../../../components/CalendarComponent';
import { MultiSelectComponent } from '../../../../components/MultiSelectComponent';
import { RiBarChartBoxFill, RiTableLine } from 'react-icons/ri';
import { IHistoryCardProvider } from '../../../../interfaces/service/HistoryCardServiceManagerInterface';
import { DropdownComponent } from '../../../../components/DropdownComponen';
import { DropdownChangeEvent } from 'primereact/dropdown';
import { useEffect } from 'react';
import { ContainerItem } from '../../../../components';

export const Filters = (props: IHistoryCardProvider) => {
  useEffect(() => {
    props.handleKeyPress(props.samField, 'sam');
  }, [props.samField]);

  useEffect(() => {
    props.handleKeyPress(props.versionField, 'version');
  }, [props.versionField]);

  useEffect(() => {
    props.handleKeyPress(props.cardNumberField, 'cardNumber');
  }, [props.cardNumberField]);

  const renderVersion = () => {
    return (
      <ContainerItem>
        <InputComponent
          type={'text'}
          name={'version'}
          value={props.versionField}
          className="h-12"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            props.setVersionField(e.target.value);
          }}
          placeholder="Filtrar por versión"
        />
      </ContainerItem>
    );
  };
  const renderSam = () => {
    return (
      <ContainerItem className=" col-span-2 items-end ">
        <InputComponent
          type={'text'}
          name={'findCardNumer'}
          value={props.samField}
          className="h-12"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            props.setSamField(e.target.value);
          }}
          placeholder="Filtrar por SAM"
          inputMode="text"
          classSpan={'p-input-icon-right'}
        />
      </ContainerItem>
    );
  };
  const renderSelectDevices = () => {
    return (
      <ContainerItem>
        <MultiSelectComponent
          options={props.devices}
          optionLabel={'name'}
          placeholder="Dispositivos"
          value={props.devicesSelected}
          className=" h-12"
          onChange={(e: MultiSelectChangeEvent) => props.selectDevices(e)}
          max={1}
          selectedItemsLabel="Seleccionado"
        />
      </ContainerItem>
    );
  };

  const renderSelectProject = () => {
    return (
      <ContainerItem>
        <MultiSelectComponent
          options={props.projects}
          optionLabel={'name'}
          placeholder="Proyectos"
          value={props.projectsSelected}
          className=" h-12"
          onChange={(e: MultiSelectChangeEvent) => props.selectProject(e)}
          max={1}
          selectedItemsLabel="Seleccionado"
        />
      </ContainerItem>
    );
  };

  const renderSelectTimePeriod = () => {
    return (
      <ContainerItem>
        <DropdownComponent
          options={props.timePeriod}
          optionLabel={'name'}
          placeholder="Tipo de periodo"
          value={props.timePeriodSelected}
          className=" h-12 !w-full"
          onChange={(e: DropdownChangeEvent) => props.selectTimePeriod(e)}
        />
      </ContainerItem>
    );
  };

  const renderSelectValidCardNumber = () => {
    return (
      <ContainerItem>
        <DropdownComponent
          options={props.validCardNumber}
          optionLabel={'name'}
          placeholder="Número de tarjeta válida"
          value={props.validCardNumberSelected}
          className=" h-12 !w-full"
          onChange={(e: DropdownChangeEvent) => props.selectValidCardNumber(e)}
        />
      </ContainerItem>
    );
  };

  const renderCardNumber = () => {
    return (
      <ContainerItem>
        <InputComponent
          type={'text'}
          name={'findCardNumer'}
          value={props.cardNumberField}
          className="h-12"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            props.setCardNumberField(e.target.value);
          }}
          placeholder="Filtrar por número de tarjeta"
          inputMode="text"
        />
      </ContainerItem>
    );
  };

  const renderFromDate = () => {
    return (
      <ContainerItem>
        <CalendarComponent
          name={'fromDate'}
          onChange={(e: { value: Date | undefined }) => {
            props.setStartDateField(e.value);
            if (e.value) {
              const dateFrom = e.value;
              const day = String(dateFrom.getDate()).padStart(2, '0');
              const month = String(dateFrom.getMonth() + 1).padStart(2, '0'); // Los meses empiezan desde 0
              const year = dateFrom.getFullYear();

              const formattedDate = `${year}-${month}-${day}`;
              props.setStartDateSend(formattedDate);
            } else {
              props.setStartDateField(undefined);
              props.setStartDateSend(undefined);
            }
          }}
          value={props.startDateField}
          placeholder="Fecha inicio"
          className=" h-12 w-full"
        />
      </ContainerItem>
    );
  };

  const renderToDate = () => {
    return (
      <ContainerItem>
        <CalendarComponent
          name={'endDate'}
          onChange={(e: { value: Date | undefined }) => {
            props.setEndDateField(e.value);
            if (e.value) {
              const dateFrom = new Date(e.value);
              const day = String(dateFrom.getDate()).padStart(2, '0');
              const month = String(dateFrom.getMonth() + 1).padStart(2, '0'); // Los meses empiezan desde 0
              const year = dateFrom.getFullYear();

              const formattedDate = `${year}-${month}-${day}`;
              props.setEndDateSend(formattedDate);
            } else {
              props.setEndDateField(undefined);
              props.setEndDateSend(undefined);
            }
          }}
          value={props.endDateField}
          placeholder="Fecha fin"
          className=" h-12 w-full"
        />
      </ContainerItem>
    );
  };

  const buttonsActions = () => {
    return (
      <div className="flex w-full h-full col-span-2 justify-between content-center items-center px-3">
        <ButtonComponent
          label="Limpiar filtro"
          onClick={props.setEmptyFilters}
          className={' w-40 h-10 sm:text-sm sm:w-28'}
        />
        <ButtonComponent
          label="Enviar"
          onClick={props.handlerFilters}
          className={'h-10 w-auto sm:text-sm'}
        />

        {!props.showChart ? (
          <RiBarChartBoxFill
            onClick={async () => {
              props.setShowChart(true);
            }}
            className="text-[50px] text-alternative_green cursor-pointer "
            title="Gráficas"
          />
        ) : (
          <RiTableLine
            onClick={async () => {
              props.setShowChart(false);
            }}
            className="text-[50px] text-alternative_green cursor-pointer "
            title="Tabla de datos"
          />
        )}
      </div>
    );
  };

  return (
    <div className="flex w-full h-full relative flex-row bg-white rounded-b-lg shadow-lg">
      <div className="grid grid-cols-6 grid-rows-2  w-full">
        {renderSam()}
        {renderSelectTimePeriod()}
        {renderFromDate()}
        {renderToDate()}
        {renderSelectDevices()}
        {renderSelectProject()}
        {renderCardNumber()}
        {renderVersion()}
        {renderSelectValidCardNumber()}
        {buttonsActions()}
      </div>
    </div>
  );
};
